module.exports = __webpack_public_path__ + "media/images/processed-21be696b7a2cf0c94b8d7f3296a7f883.svg";